import React from 'react';
import Header from './Components/Header/Header';
import Footer from './Components/Footer/Footer';
import Home from './Pages/Home/Home';
import Sexuality from './Pages/Sexuality/Sexuality';
import Gender from './Pages/Gender/Gender';
import SexualityTips from './Pages/TipsAndAdvice/Tips';
import GenderTips from './Pages/GenderTips/GenderTips';
import Allies from './Pages/Allies/Allies';
import AllyTips from './Pages/AllyTips/AllyTips';
import Helplines from './Pages/Helplines/Helplines';
import Glossary from './Pages/Glossary/Glossary';
import SexualityBlog from './Pages/Blogs/Sexuality/SexualityBlog';
import WhatIsSexuality from './Pages/Blogs/Sexuality/blogs/whatissexuality';
import PippasStory from './Pages/Blogs/Sexuality/blogs/pippasstory';
import GenderBlog from './Pages/Blogs/Gender/GenderBlog';
import WhatIsGender from './Pages/Blogs/Gender/blogs/whatisgender';
import TransStories from './Pages/Blogs/Gender/blogs/transstories';
import AllyBlog from './Pages/Blogs/Ally/AllyBlogs';
import BecomingAnAlly from './Pages/Blogs/Ally/blogs/BecomingAnAlly';
import HowToBeAnAlly from './Pages/Blogs/Ally/blogs/HowToBeAnAlly';
import ProudAlly from './Pages/Blogs/Ally/blogs/ProudAlly';
import Determintation from './Pages/Blogs/Gender/blogs/determination';
import ComingOut from './Pages/Blogs/Sexuality/blogs/comingout';
import './App.css';
import { Router } from '@reach/router';




function App() {
  return (
   
   <div>
     
     <Header/>
  <Router>
        <Home path ="/"/>
        <Sexuality path ="/sexuality"/>
        <Gender path = "/gender"/>
        <SexualityTips path = "/sexualitytips"/>
        <GenderTips path = "/gendertips"/>
        <Allies path = "/allies"/>
        <AllyTips path = "/allytips"/>
        <Helplines path ="/helplines"/> 
        <Glossary path ="/glossary"/>
        <SexualityBlog path = "/sexualityblog"/>
        <WhatIsSexuality path = "/whatissexuality"/>
        <PippasStory path = "/pippasstory"/>
        <GenderBlog path = "/genderblogs"/>
        <WhatIsGender path = "/whatisgender"/>
        <TransStories path = "/transstories"/>
        <AllyBlog path = "/allyblogs"/>
        <BecomingAnAlly path = "/becominganally"/>
        <HowToBeAnAlly path = "/howtobeanally"/>
        <ProudAlly path = "/proudally"/>
        <Determintation path = "/determination"/>
        <ComingOut path = "/comingout"/>
      
    </Router> 
    <Footer/>
   </div>
  );
}
export default App;
